import React from 'react'
import Header from "../../aboutus/aboutusheader/AboutHeader"
// import "./Terms_page_header.css"
// import Logo from "../../../Assets/Logo-min.png"

// import Header_2 from "../../ekemini_about_us_pages/ekemini_about_us_page_header/About_page_header"


function Terms_page_header() {
    return (
        <div>
            <Header />
        </div>
    )
}

export default Terms_page_header;
